export default __webpack_public_path__ + "static/media/trash.4ef3bc7d.svg";